import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONTRACT_DETAILS_EXPERIENCE_API,
});
const OKTA_API_KEY = process.env.REACT_APP_EXPERIENCE_API_ST;
const APPLICATION_JSON = 'application/json';
const CONTENT_TYPE = 'Content-Type';

export const setupAxiosClientOcta = ({dispatch, getState}, axiosInstance) => {
  const onRequestSuccess = (config) => {
    config.headers['Accept'] = APPLICATION_JSON;
    config.headers[CONTENT_TYPE] = APPLICATION_JSON;
    config.headers['Authorization'] = OKTA_API_KEY;
    config.headers['trace_id'] = localStorage.getItem('trace-id');
    return config;
  };

  const onRequestError = (error) => Promise.reject(error.response);

  const onResponseSucess = (response) => response;
  const onResponseError = (error) => Promise.reject(error);

  axiosInstance.interceptors.request.use(onRequestSuccess, onRequestError);
  axiosInstance.interceptors.response.use(onResponseSucess, onResponseError);
};

export default instance;
